import React from 'react'

export const LoginSidebar = () => {
  return (
    <div className="hidden md:block md:w-1/2 bg-gray-100">
      <div className="h-full w-full relative">
        <div className="absolute inset-0 bg-gradient-to-br from-teal-500/80 to-teal-700/90 z-10"></div>
        <div
          className="absolute inset-0 bg-cover bg-center z-0"
          style={{ 
            backgroundImage: "url('https://images.unsplash.com/photo-1564013799919-ab600027ffc6?ixlib=rb-4.0.3&auto=format&fit=crop&w=1920&q=80')",
            backgroundAttachment: "fixed"
          }}
        ></div>
        <div className="absolute inset-0 flex flex-col justify-center items-center z-20 p-12 text-white">
          <h2 className="text-2xl md:text-3xl font-bold mb-6 text-center">
            Find Your Ideal Property in the UAE
          </h2>
          <p className="text-base md:text-lg text-center max-w-md">
            Direct from developers, no agents involved. Exclusive off-plan properties with AI-powered recommendations.
          </p>
        </div>
      </div>
    </div>
  )
}